import axios, { AxiosRequestConfig } from 'axios'
import {
  api_job_number_path,
  jobnumbers_path,
  change_status_jobnumbers_path,
  get_status_jobnumbers_path,
  nav_folder_api_job_number_path,
  sync_api_job_numbers_path,
  sync_status_api_job_numbers_path,
} from '../routes'
import { OrderNumberOption } from '../components/shared/order_number_picker/types'

export function loadJobnumberOptions(filter: string, callback: (options: OrderNumberOption[]) => void): void {
  const ajaxParams: AxiosRequestConfig = {
    url: jobnumbers_path(),
    method: 'get',
    responseType: 'json',
    params: { q: filter },
  }
  axios(ajaxParams)
    .then((response) => {
      const { data } = response
      if (data) {
        const options = data.map((jn) => {
          return { label: jn.full_title, value: jn.id, jobnumber: jn }
        })
        callback(options)
      } else {
        callback([])
      }
    })
    .catch(() => {
      callback([])
    })
}

export function loadOrderNumberOptions(filter: string, callback: (options: OrderNumberOption[]) => void): void {
  const ajaxParams: AxiosRequestConfig = {
    url: jobnumbers_path(),
    method: 'get',
    responseType: 'json',
    params: { q: filter },
  }
  axios(ajaxParams)
    .then((response) => {
      const { data } = response
      if (data) {
        const options = data.map((jn) => {
          return { label: jn.job_id_title, value: jn.id, jobnumber: jn }
        })
        callback(options)
      } else {
        callback([])
      }
    })
    .catch(() => {
      callback([])
    })
}

export function changeJobnumberStatus(payload: Record<string, any> = {}): Promise<any> {
  const options: AxiosRequestConfig = {
    url: change_status_jobnumbers_path({ format: 'json' }),
    method: 'post',
    responseType: 'json',
    data: payload,
  }
  return axios(options)
}

export function getJobnumberStatus(payload: Record<string, any> = {}): Promise<any> {
  const options: AxiosRequestConfig = {
    url: get_status_jobnumbers_path({ format: 'json' }),
    method: 'get',
    responseType: 'json',
    params: payload,
  }
  return axios(options)
}

export function toggleJobnumberFavourite(jobnumberId: number): Promise<{ is_favourite: boolean }> {
  const options: AxiosRequestConfig = {
    url: `/jobnumbers/${jobnumberId}/toggle_favourite`,
    method: 'post',
    responseType: 'json',
  }
  return axios(options).then((response) => response.data)
}

export function syncJobnumbers(): Promise<{ status: string }> {
  const options: AxiosRequestConfig = {
    url: sync_api_job_numbers_path({ format: 'json' }),
    method: 'post',
    responseType: 'json',
  }
  return axios(options).then((response) => response.data)
}

export function getJobnumbersSyncStatus(): Promise<{ status: 'idle' | 'in_progress' }> {
  const options: AxiosRequestConfig = {
    url: sync_status_api_job_numbers_path({ format: 'json' }),
    method: 'get',
    responseType: 'json',
  }
  return axios(options).then((response) => response.data)
}

export function getNavFolder(jobnumberId: number): Promise<{ path_folder: string | null }> {
  const options: AxiosRequestConfig = {
    url: nav_folder_api_job_number_path(jobnumberId, { format: 'json' }),
    method: 'get',
    responseType: 'json',
  }
  return axios(options).then((response) => response.data)
}

export function getJobnumberById(id: number): Promise<any> {
  const options: AxiosRequestConfig = {
    url: api_job_number_path(id),
    method: 'get',
    responseType: 'json',
  }
  return axios(options).then((response) => response.data)
}
